import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LogApiService } from 'features/log/api/log-api.services';
import { UserListParams } from 'features/users';
import qs from 'qs';

import { LogQueryKeys } from './query-keys';
const { getLog } = LogApiService();

const getUsersQuery = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: LogQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getLog(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetLogList = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








